import Link from 'next/link'
import { RESEARCH_METHODS_PATH } from '@dupe/common/research-report'

/**
 * Monetization disclosure shown on research report and hub pages. Buy
 * buttons route through monetized /redirect/ links, so every page that
 * renders them needs a visible affiliate disclosure (FTC + Google trust
 * requirement, June 2026 EEAT audit P0.4).
 */
export function SeoReportDisclosure() {
  return (
    <p className='text-center text-xs leading-5 text-foreground-tertiary'>
      Dupe may earn a commission when you buy through links on this page, at no
      extra cost to you. Commissions never influence our research or rankings.{' '}
      <Link
        href={RESEARCH_METHODS_PATH}
        className='underline decoration-border underline-offset-2 transition-colors hover:text-foreground-secondary hover:decoration-foreground-secondary'
      >
        Learn more &rsaquo;
      </Link>
    </p>
  )
}
